import UserSyncWarningToastContent from 'components/toast/UserSyncWarningToastContent'
import { toast } from 'react-toastify'

/**
 * Options par défaut du toast
 * @returns ToastPosition
 */
export const defaultToast = () => {
  return {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
}

/**
 * Affiche un toast de succès avec le texte passé en paramètre
 * @param text
 */
export const successToast = (text) => {
  toast.success(text, {
    ...defaultToast(),
  })
}

export const infoToast = (text, options = {}) => {
  toast.info(text, {
    ...defaultToast(),
    ...options,
  })
}

export const loadingToast = (text) => {
  return toast.info(text, {
    ...defaultToast(),
    autoClose: false,
    closeButton: false,
  })
}

/**
 * Affiche un toast d'erreur avec le texte passé en paramètre
 * @param text
 */
export const errorToast = (text) => {
  toast.error(text, {
    ...defaultToast(),
  })
}

/**
 * Affiche un toast de warning avec le texte passé en paramètre
 * @param text
 */
export const warningToast = (text) => {
  toast.warning(text, {
    ...defaultToast(),
  })
}

export const userSyncWarningToast = (data) => {
  toast.warning(UserSyncWarningToastContent, {
    data,
    ...defaultToast(),
  })
}

export default { errorToast, successToast, loadingToast }
